import { useState, useEffect, type FC } from 'react';
import { Megaphone } from 'lucide-react';
import { GuidedTour } from '@/components/onboarding/GuidedTour';
import { usePageTour } from '@/hooks/usePageTour';
import { campaignsTourSteps } from '@/lib/tour-data';
import CampaignTable, { type Campaign } from './components/CampaignTable';
import CampaignDetailModal from './components/CampaignDetailModal';

const TOUR_ID = 'admin-campaigns';

const CampaignsPage: FC = () => {
  const tour = usePageTour(TOUR_ID);
  useEffect(() => {
    const handler = () => tour.startTour();
    window.addEventListener('restart-page-tour', handler);
    return () => window.removeEventListener('restart-page-tour', handler);
  }, [tour]);

  const [selectedCampaign, setSelectedCampaign] = useState<Campaign | null>(null);
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="space-y-6">
      {/* Header gradient */}
      <div
        className="fc-gradient-header rounded-2xl p-6 text-white"
        style={{ background: 'linear-gradient(135deg, #3b82f6, #6366f1)' }}
      >
        <div className="flex items-center gap-3" data-tour="campaigns-header">
          <Megaphone className="h-6 w-6" />
          <div>
            <h1 className="text-xl font-bold">Campaigns</h1>
            <p className="mt-0.5 text-xs italic text-blue-200">Campagnes</p>
            <p className="mt-1 text-sm text-blue-100">
              Suivi des campagnes marketing — KPIs &amp; Contenus lies
            </p>
          </div>
        </div>
      </div>

      {/* Tableau campagnes */}
      <CampaignTable
        onCampaignClick={(c) => {
          setSelectedCampaign(c);
          setModalOpen(true);
        }}
        onNewCampaign={() => {
          setSelectedCampaign(null);
          setModalOpen(true);
        }}
      />

      {/* Modal detail */}
      <CampaignDetailModal
        open={modalOpen}
        campaign={selectedCampaign}
        onClose={() => {
          setModalOpen(false);
          setSelectedCampaign(null);
        }}
      />
      <GuidedTour tourId={TOUR_ID} steps={campaignsTourSteps} isActive={tour.isActive} onComplete={tour.completeTour} onSkip={tour.skipTour} />
    </div>
  );
};

export default CampaignsPage;
